import Link from "next/link"
import Image from "next/image"

const HEADER_MENUS_DESKTOP = [
  {
    label: "bird feeders",
    href: "/bird-feeders",
    subMenu: (
      <div className="flex items-start justify-between px-[100px] py-[40px]">
        <div className="flex flex-col items-start">
          <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
            Featured
          </p>
          <div className="flex flex-col gap-[15px]">
            <Link
              className="cursor-pointer font-sans text-sm font-[600] leading-[1.4] text-title hover_text-primary hover_underline"
              href="/bird-feeders"
            >
              View All Bird Feeders
            </Link>

            <Link
              className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
              href="/squirrel-proof-feeders"
            >
              Squirrels Proof Feeders{" "}
            </Link>
            <Link
              className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
              href="/hummingbird-feeders"
            >
              Hummingbird Feeders
            </Link>
            <Link
              className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
              href="/cardinal-feeders"
            >
              Cardinal Feeders
            </Link>
            <Link
              className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
              href="/bluebird-feeders"
            >
              Bluebird Feeders
            </Link>
            <Link
              className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
              href="/suet-bird-feeders"
            >
              Suet Feeders
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
            Shop by Bird Speices
          </p>
          <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px]">
            <Link
              href="/hummingbird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/bird-speices-1.png"
              />
              <p className="mt-[10px] break-words text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Hummingbirds
              </p>
            </Link>
            <Link
              href="/bluebird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/bird-speices-2.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Bluebirds
              </p>
            </Link>
            <Link
              href="/cardinal-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/bird-speices-3.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Cardinals
              </p>
            </Link>
            <Link
              href="/oriole-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/bird-speices-4.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Orioles
              </p>
            </Link>
            <Link
              href="/woodpecker-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/bird-speices-5.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Woodpeckers
              </p>
            </Link>
            <Link
              href="/blue-jay-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/bird-speices-6.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Blue Jays
              </p>
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
            Shop by Feeder Type
          </p>
          <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px]">
            <Link
              href="/platform-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feeder-type-1.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Platform Feeders
              </p>
            </Link>
            <Link
              href="/suet-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feeder-type-2.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Suet Feeders
              </p>
            </Link>
            <Link
              href="/hopper-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feeder-type-3.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Hopper Feeders
              </p>
            </Link>
            <Link
              href="/house-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feeder-type-4.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                House Feeders
              </p>
            </Link>
            <Link
              href="/tube-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feeder-type-5.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Tube Feeders
              </p>
            </Link>
            <Link
              href="/caged-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feeder-type-6.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Caged Feeders
              </p>
            </Link>
          </div>
        </div>
        <div className="flex flex-col items-start">
          <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
            Shop by Features
          </p>
          <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px]">
            <Link
              href="/squirrel-proof-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feature-1.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Squirrel Proof Feeders
              </p>
            </Link>
            <Link
              href="/weatherproof-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feature-2.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Weatherproof Feeders{" "}
              </p>
            </Link>
            <Link
              href="/recycled-plastic-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feature-3.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Recycled Plastic Feeders{" "}
              </p>
            </Link>
            <Link
              href="/metal-mesh-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/feature-4.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Metal Mesh Feeders{" "}
              </p>
            </Link>
          </div>
        </div>

        <div>
          <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
            Shop by Seed Type
          </p>
          <div className="grid grid-cols-3 gap-x-[10px] gap-y-[25px]">
            <Link
              href="/sunflower-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/seed-type-1.png"
              />
              <p className="mt-[10px] break-words text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Sunflower
              </p>
            </Link>
            <Link
              href="/suet-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/seed-type-2.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Suets
              </p>
            </Link>
            <Link
              href="/mixed-seed-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/seed-type-3.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Mixed Seeds
              </p>
            </Link>
            <Link
              href="/fruit-nuts-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/seed-type-4.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Fruit & Nuts
              </p>
            </Link>
            <Link
              href="/mealworm-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/seed-type-5.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Mealworms
              </p>
            </Link>
            <Link
              href="/nyjer-thistle-bird-feeders"
              className="group flex w-[80px] cursor-pointer flex-col justify-start"
            >
              <Image
                className="w-full"
                alt=""
                width={160}
                height={160}
                layout="responsive"
                src="/images/header-menu/seed-type-6.png"
              />
              <p className="mt-[10px] text-center font-sans text-sm text-title group-hover_text-primary group-hover_underline">
                Nyjer
              </p>
            </Link>
          </div>
        </div>
      </div>
    ),
    hasDropdownMenu: true,
  },
  {
    label: "Smart Feeders",
    href: "/smart-bird-feeders",
    hasDropdownMenu: true,
    subMenu: (
      <div className="flex items-center justify-center gap-[100px] py-[40px]">
        <Link
          href="/titto-smart-bird-feeder-pro-ttbf001cp.html"
          className="group flex cursor-pointer flex-col items-center"
        >
          <Image
            className="w-[500px]"
            alt=""
            width={500}
            height={300}
            layout="responsive"
            src="/images/header-menu/smart-bird-feeder.png"
          />
          <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
            Smart Bird Feeder
          </p>
        </Link>
        <Link
          href="/titto-2-in-1-smart-bird-feeder-ttbf002cp.html"
          className="group flex cursor-pointer flex-col items-center"
        >
          <Image
            className="w-[500px]"
            alt=""
            width={500}
            height={300}
            layout="responsive"
            src="/images/header-menu/smart-bird-versa-feeder.png"
          />
          <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
            Smart Bird Versa Feeder
          </p>
        </Link>
      </div>
    ),
  },
  {
    label: "bird houses",
    href: "/bird-houses",
    hasDropdownMenu: true,
    subMenu: (
      <div className="flex w-full justify-center">
        <div className="flex w-[1440px] max-w-full items-start justify-between py-[40px]">
          <div className="flex flex-col items-start">
            <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
              Featured
            </p>
            <div className="flex flex-col gap-[15px]">
              <Link
                className="cursor-pointer font-sans text-sm font-[600] leading-[1.4] text-title hover_text-primary hover_underline"
                href="/bird-houses"
              >
                View All Bird Houses
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/bluebird-houses"
              >
                Bluebird Houses
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/decorative-houses"
              >
                Decorative Houses
              </Link>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
              Bird Houses
            </p>
            <div className="flex flex-col gap-[15px]">
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/bluebird-houses"
              >
                Bluebird Houses
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/chickadee-houses"
              >
                Chikadee Houses{" "}
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/wren-houses"
              >
                Wren Houses
              </Link>
            </div>
          </div>

          <Link
            href="/bluebird-houses"
            className="group flex cursor-pointer flex-col items-center"
          >
            <Image
              className="w-[500px]"
              alt=""
              width={500}
              height={300}
              layout="responsive"
              src="/images/header-menu/bird-house.png"
            />
            <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
              Bluebird House
            </p>
          </Link>
        </div>
      </div>
    ),
  },
  {
    label: "bird baths",
    href: "/bird-baths",
    hasDropdownMenu: false,
  },
  {
    label: "accessories",
    href: "/accessories",
    hasDropdownMenu: true,
    subMenu: (
      <div className="flex w-full justify-center">
        <div className="flex w-[1440px] max-w-full items-start justify-between py-[40px]">
          <div className="flex flex-col items-start">
            <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
              Featured
            </p>
            <div className="flex flex-col gap-[15px]">
              <Link
                className="cursor-pointer font-sans text-sm font-[600] leading-[1.4] text-title hover_text-primary hover_underline"
                href="/accessories"
              >
                View All Accessories
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/poles-hanger-hooks"
              >
                Poles Systems & Hangers
              </Link>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
              Birding Accessories
            </p>
            <div className="flex flex-col gap-[15px]">
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/bird-feeder-accessories"
              >
                Bird Feeder Accessories
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/poles-hanger-hooks"
              >
                Poles & Hangers
              </Link>
            </div>
          </div>
          <div className="flex flex-col items-start">
            <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
              Garden Essentials
            </p>
            <div className="flex flex-col gap-[15px]">
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/garden-yard-essentials"
              >
                Garden & Yard Essentials
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/garden-fencing-privacy-screens"
              >
                Fencing & Privacy Screens
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/squirrel-feeders"
              >
                Squirrel Feeders
              </Link>
            </div>
          </div>

          <Link
            href="/garden-yard-essentials"
            className="group flex cursor-pointer flex-col items-center"
          >
            <Image
              className="w-[400px]"
              alt=""
              width={400}
              height={260}
              layout="responsive"
              src="/images/header-menu/accessories.png"
            />
            <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
              Garden Yard Accessories
            </p>
          </Link>
        </div>
      </div>
    ),
  },
  {
    label: "gifts",
    href: "/gifts",

    hasDropdownMenu: true,
    subMenu: (
      <div className="flex w-full justify-center">
        <div className="flex w-[1440px] max-w-full items-start justify-between py-[40px]">
          <div className="flex flex-col items-start">
            <p className="mb-[25px] font-poppins font-[600] leading-[1.2] text-title">
              Gift Ideas
            </p>
            <div className="flex flex-col gap-[15px]">
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/top-picked-gifts-for-bird-lovers"
              >
                Top Pick Gifts
              </Link>
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/gifts-under-30"
              >
                Gifts under $30
              </Link>{" "}
              <Link
                className="cursor-pointer font-sans text-sm leading-[1.4] text-title hover_text-primary hover_underline"
                href="/gifts-under-50"
              >
                Gifts under $50{" "}
              </Link>
            </div>
          </div>
          <div className="flex flex-1 items-center justify-center">
            <Link
              href="/garden-decor-gifts"
              className="group flex cursor-pointer flex-col items-center"
            >
              <Image
                className="w-[500px]"
                alt=""
                width={500}
                height={300}
                layout="responsive"
                src="/images/header-menu/garden-gifts.png"
              />
              <p className="mt-[10px] font-poppins font-[600] leading-[1.2] text-title group-hover_text-primary group-hover_underline">
                garden gifts
              </p>
            </Link>
          </div>
        </div>
      </div>
    ),
  },
]

export default HEADER_MENUS_DESKTOP
